import {  ADD_USER_RED, DELETE_USER_RED, GET_USER_RED, UPDATE_USER_RED } from "../Constant";
const initialState = [];
export function UserReducer(state = initialState, action){
    var newState
    switch (action.type) {
        case ADD_USER_RED:      
           return [...state, action.data];
        case GET_USER_RED:
            return action.data
        case DELETE_USER_RED:
            newState = state.filter(item=>item._id!==action.data._id)
            return newState
        case UPDATE_USER_RED:
            newState = state
            var index = newState.findIndex((item)=>item._id===(action.data._id))
            newState[index] = action.data
            return newState
        default:
            return state
    }
}